import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PageNotFound from './pages/pagenotfound';
import Synkronisering from './admin/synkronisering/synkronisering';
import {
  AboutAnalyticsPageLoggedIn,
  AboutCookiesPageLoggedIn,
} from './login/about';
import Praksisstedsok from './admin/praksisstedsok';
import MyUsers from './admin/brukere/myUsers';
import AddStudiestedbruker from './admin/studiestedbruker/addStudiestedbruker';
import AddSystembruker from './admin/systembruker/addSystembruker';

const RoutesAdmin = () => (
  <Routes>
    <Route path="/" element={<Praksisstedsok />} />
    <Route path="/cookies" element={<AboutCookiesPageLoggedIn />} />
    <Route path="/analytics" element={<AboutAnalyticsPageLoggedIn />} />
    <Route path="/sync" element={<Synkronisering />} />
    <Route path="/myusers" element={<MyUsers />} />
    <Route path="/addstudiestedbruker" element={<AddStudiestedbruker />} />
    <Route path="/addsystembruker" element={<AddSystembruker />} />
    <Route path="/*" element={<PageNotFound />} />
  </Routes>
);

export default RoutesAdmin;
